import { authHeader } from "../helpers/auth-header";
import axios from 'axios';

function getMenu() {
    return axios.get('/api/dashboard/getmenu', {headers: authHeader()})
        .then(res => {
            return res.data;
        });
}

export const panelService = {
    getMenu,
};
